export const UPDATE_GROUP_TRANSACTION_STATUS_START =
  'UPDATE_GROUP_TRANSACTION_STATUS_START';
export const UPDATE_GROUP_TRANSACTION_STATUS_SUCCESS =
  'UPDATE_GROUP_TRANSACTION_STATUS_SUCCESS';
export const UPDATE_GROUP_TRANSACTION_STATUS_ERROR =
  'UPDATE_GROUP_TRANSACTION_STATUS_ERROR';
